import React from 'react';
import { Card, List, Tag } from 'antd';
import { StarOutlined } from '@ant-design/icons';

const { Meta } = Card;

type CardProps = {
  name: string;
};

function FoodItemCard({ name }: CardProps) {
  return (
    <Card
      hoverable
      cover={
        <img
          style={{ height: 160, objectFit: 'cover', padding: 10 }}
          alt="example"
          src={name}
        />
      }
    >
      <Meta
        title="Food Den"
        description="Continental, Indian, Pan-Asian, Oriental"
      />
      <List itemLayout="horizontal">
        <List.Item>
          <List.Item.Meta
            description={
              <div style={{ display: 'flex', fontSize: 12 }}>
                <div style={{ flex: 1 }}>
                  <Tag icon={<StarOutlined />} color="#48c479">
                    4.3
                  </Tag>
                </div>
                <div style={{ flex: 1 }}>38 MINS</div>
                <div style={{ flex: 1 }}>₹200 FOR TWO</div>
              </div>
            }
          />
        </List.Item>
        <List.Item>
          <List.Item.Meta
            description={
              <div style={{ display: 'flex', fontSize: 12 }}>
                <div style={{ flex: 1, color: '#8a584b', fontWeight: 600 }}>
                  50% OFF | Use Coupon LETSEATFOOD
                </div>
              </div>
            }
          />
        </List.Item>
      </List>
    </Card>
  );
}

export default FoodItemCard;
